import { Show, SignInButton, SignUpButton, UserButton } from "@clerk/react";

/** Clerk sign-in / sign-up / account button. Independent of MarkovLab session. */
export default function ClerkAuthControls({ compact = false }) {
  const btn = compact
    ? "h-7 px-3 text-xs font-semibold rounded-md"
    : "h-9 px-4 text-sm font-semibold rounded-sm";
  return (
    <div className="flex items-center gap-2" data-testid="clerk-auth-controls">
      <Show when="signed-out">
        <SignInButton mode="modal" forceRedirectUrl="/dashboard" fallbackRedirectUrl="/dashboard">
          <button type="button" className={`${btn} border`} data-testid="clerk-signin-btn"
            style={{ borderColor: "var(--hoip-border, #27272A)", color: "var(--hoip-text-primary, #F4F4F5)" }}>
            Sign in
          </button>
        </SignInButton>
        <SignUpButton mode="modal" forceRedirectUrl="/dashboard" fallbackRedirectUrl="/dashboard">
          <button type="button" className={btn} data-testid="nav-cta"
            style={{ background: "#00c896", color: "#0a0a0a" }}>
            Sign up
          </button>
        </SignUpButton>
      </Show>
      <Show when="signed-in">
        <UserButton />
      </Show>
    </div>
  );
}
